<!-- Page Content -->
<div class="content">
    <div class="container">
        <div class="row">
            <div class="col-md-6 offset-md-3">

                <!-- Login Content -->
                <div class="account-content">
                    <div class="align-items-center justify-content-center">
                        <div class="login-right">
                            <div class="login-header text-center">
                                <a [routerLink] = "'/home'"><img src="assets/img/logo-01.png" alt="logo" class="img-fluid"></a>
                                <h3>Restablece tu contraseña</h3>
                                <p>Recuerda utilizar una contraseña segura</p>
                              <div class="error-container" *ngIf="!resetSuccess">
                                <div *ngIf="submitted && this.resetPasswordForm.controls.password.errors?.required">La clave es obligatoria</div>
                                <div *ngIf="submitted && this.resetPasswordForm.controls.passwordConfirm.errors?.required">La confirmación de clave es obligatoria</div>
                                <div *ngIf="submitted && this.resetPasswordForm.controls.passwordConfirm.errors?.noPasswordMatch">La clave y la confirmación no coinciden</div>
                                <div *ngIf="resetError">{{'Ocurrió un error al restablecer la contraseña'}}</div>
                              </div>
                              <div class="success-container">
                                <div *ngIf="resetSuccess && submitted">Tu contraseña fue reestablecida con éxito</div>
                                <div *ngIf="resetSuccess && submitted">Puede ingresa haciendo click <a [routerLink]="'/login'" class="link-primary">aquí</a> </div>
                              </div>
                            </div>
                          <form [formGroup]="resetPasswordForm" (ngSubmit)="enviar(resetPasswordForm.value)">
                            <div class="form-group form-focus mb-2">
                              <div class="input-wrapper">
                                <i class="custom-icon fas" [ngClass]="{ 'fa-eye': !showPassword, 'fa-eye-slash': showPassword }" (click)="togglePasswordVisibility()"></i>
                                <input type="{{ showPassword ? 'text' : 'password' }}" formControlName="password" class="form-control floating" placeholder="Contraseña">
                                <label class="focus-label" [ngClass]="{'filled': resetPasswordForm.controls.password.value}">Contraseña</label>
                              </div>
                            </div>
                            <ng-container *ngIf="!(resetSuccess && submitted)">
                              <div [ngClass]="resetPasswordForm.controls['password'].hasError('required') || resetPasswordForm.controls['password'].hasError('minlength')  ? 'text-danger2' :'text-success'">
                                <hugeicons-icon 
                                  [icon]="resetPasswordForm.controls['password'].hasError('resetPasswordForm') ||resetPasswordForm.controls['password'].hasError('minlength') ? CancelCircleIcon : CheckmarkCircle02Icon" 
                                  [size]="13">
                                </hugeicons-icon>
                                La clave debe tener al menos 8 caracteres
                              </div>
                              <div [ngClass]="resetPasswordForm.controls['password'].hasError('required') || resetPasswordForm.controls['password'].hasError('hasNumber')  ? 'text-danger2' :'text-success'">
                                <hugeicons-icon 
                                  [icon]="resetPasswordForm.controls['password'].hasError('required') ||resetPasswordForm.controls['password'].hasError('hasNumber') ? CancelCircleIcon : CheckmarkCircle02Icon" 
                                  [size]="13">
                                </hugeicons-icon>
                                La clave debe contener al menos un número
                              </div>
                              <div [ngClass]="resetPasswordForm.controls['password'].hasError('required') || resetPasswordForm.controls['password'].hasError('hasCapitalCase')  ? 'text-danger2' :'text-success'">
                                <hugeicons-icon 
                                  [icon]="resetPasswordForm.controls['password'].hasError('required') ||resetPasswordForm.controls['password'].hasError('hasCapitalCase') ? CancelCircleIcon : CheckmarkCircle02Icon" 
                                  [size]="13">
                                </hugeicons-icon>
                                La clave debe contener al menos una mayúscula
                              </div>
                              <div [ngClass]="resetPasswordForm.controls['password'].hasError('required') || resetPasswordForm.controls['password'].hasError('hasSmallCase')  ? 'text-danger2' :'text-success'">
                                <hugeicons-icon 
                                  [icon]="resetPasswordForm.controls['password'].hasError('required') ||resetPasswordForm.controls['password'].hasError('hasSmallCase') ? CancelCircleIcon : CheckmarkCircle02Icon" 
                                  [size]="13">
                                </hugeicons-icon>
                                La clave debe contener al menos una minúscula
                              </div>
                            </ng-container>

                            <div class="form-group form-focus mb-2">
                              <div class="input-wrapper">
                                <i class="custom-icon fas" [ngClass]="{ 'fa-eye': !showConfirmPassword, 'fa-eye-slash': showConfirmPassword }" (click)="toggleConfirmPasswordVisibility()"></i>
                                <input type="{{ showConfirmPassword ? 'text' : 'password' }}" formControlName="passwordConfirm" class="form-control floating" placeholder="Confirmar Contraseña">
                                <label class="focus-label" [ngClass]="{'filled': resetPasswordForm.controls.passwordConfirm.value}">Confirmar Contraseña</label>
                              </div>
                            </div>
                            <button class="btn btn-primary btn-block btn-lg login-btn mt-4" type="submit">Restablecer</button>
                            <div class="row">
                              <div class="col-5 text-start">
                                <a class="forgot-link" [routerLink] = "'/'">¿Ya estás registrado?</a>
                              </div>
                              <div class="col-7 text-end dont-have">¿Eres nuevo en Mercado Cheque? <a class="text-nowrap" [routerLink] = "'/register'">Click aquí</a></div>
                            </div>
                          </form>

<!--                                <div class="login-or">-->
<!--                                    <p>Or login with</p>-->
<!--                                </div>-->
<!--                                <div class="row social-login">-->
<!--                                    <div class="col-4">-->
<!--                                        <a href="#" class="btn btn-twitter btn-block"> Twitter</a>-->
<!--                                    </div>-->
<!--                                    <div class="col-4">-->
<!--                                        <a href="#" class="btn btn-facebook btn-block"> Facebook</a>-->
<!--                                    </div>-->
<!--                                    <div class="col-4">-->
<!--                                        <a href="#" class="btn btn-google btn-block"> Google</a>-->
<!--                                    </div>-->
<!--                                </div>-->
                        </div>
                    </div>
                </div>
                <!-- /Login Content -->

            </div>
        </div>
    </div>
</div>
<!-- /Page Content -->
